












import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component({})
export default class ScreenLocker extends Vue {
  @Prop({ default: false }) hasBackground?: boolean;
  @Prop({ default: false }) hasMediumBackgroundLocker?: boolean;
  @Prop({ default: false }) active?: boolean;
  @Prop({ default: false }) isMainScreenLocker?: boolean;
  @Prop({ default: 'none' }) activePointerEvents?: string;

  @Watch('active')
  handleActiveChange() {
    if (!this.isMainScreenLocker) return;

    const routerViewEl = document.querySelector<HTMLElement>(
      '.router-view-container'
    );
    const sideMenuEl = document.querySelector<HTMLElement>(
      '.container-col--secondary-menu'
    );
    const activeClass = '--screen-locker-is-active';

    if (!routerViewEl || !sideMenuEl) return;

    document.documentElement.style.setProperty(
      '--side-menu-width',
      `${sideMenuEl.clientWidth}px`
    );

    if (this.active) routerViewEl.classList.add(activeClass);
    else routerViewEl.classList.remove(activeClass);
  }
}
